import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { NogoshIconPipe } from '../icons/nogosh-icon.pipe';
import { ChatService } from '../services/chat.service';
import { DelayedSpinnerService } from '../services/delayed-spinner.service';
import { DialogService } from '../../core/dialog/dialog.service';
import { TranslateService } from '@ngx-translate/core';
import { finalize } from 'rxjs/operators';

import { PlayerContactActions } from '../models/player-contact-actions';

@Component({
  selector: 'app-player-contact-actions',
  standalone: true,
  imports: [TranslateModule, NogoshIconPipe],
  template: `
    @if (actions?.canChat) {
      <button type="button" (click)="openChat()" [disabled]="busy" [title]="'players.chat' | translate" [attr.aria-label]="'players.chat' | translate">
        <i [class]="'chat.chat' | nogoshIcon" aria-hidden="true"></i>
      </button>
    }
    @if (actions?.canCall && actions?.phoneNumber) {
      <a [href]="'tel:' + actions.phoneNumber" [title]="'players.call' | translate" [attr.aria-label]="'players.call' | translate"><i [class]="'player.phone' | nogoshIcon" aria-hidden="true"></i></a>
    }
    @if (actions?.canEmail && actions?.email) {
      <a [href]="'mailto:' + actions.email" [title]="'common.email' | translate" [attr.aria-label]="'common.email' | translate"><i [class]="'player.email' | nogoshIcon" aria-hidden="true"></i></a>
    }
  `,
  styles: [`:host { display: inline-flex; align-items: center; gap: var(--nogosh-space-sm); }
    button, a { display: inline-flex; align-items: center; justify-content: center; min-width: 40px; min-height: 40px; border: 1px solid var(--nogosh-border); border-radius: var(--nogosh-radius-lg); background: transparent; color: var(--nogosh-brand-primary); font-size: var(--nogosh-font-size-lg); text-decoration: none; }
    button:disabled { opacity: .5; }`]
})
export class PlayerContactActionsComponent {
  @Input() player: { id?: string; contactActions?: PlayerContactActions };
  @Output() chat = new EventEmitter<void>();
  busy = false;
  get actions(): PlayerContactActions | undefined { return this.player?.contactActions; }
  constructor(private chats: ChatService, private router: Router, private spinner: DelayedSpinnerService,
    private dialogs: DialogService, private translate: TranslateService) {}
  openChat(): void {
    if (!this.actions?.canChat || this.busy) return;
    if (this.chat.observed) { this.chat.emit(); return; }
    this.busy = true;
    const finish = this.spinner.acquire();
    this.chats.openDirectChat(this.actions.playerId).pipe(finalize(() => { this.busy = false; finish(); })).subscribe({
      next: result => this.router.navigate(['/messages', { chatId: result.chat.id }]),
      error: () => this.dialogs.alert({ title: this.translate.instant('common.alert'), text: this.translate.instant('chat.openError') })
    });
  }
}
